export default {
  'adb-filter': {
    collapseAll: '折叠全部',
    expandAll: '展开全部',
    SelectAll: '选择全部',
    minimumAmount: '最小金额',
    maximumAmount: '最大金额',
    minimumNumber: '最小值',
    maximumNumber: '最大值',
    startDate: '开始日期',
    endDate: '结束日期',
    searchBy: '输入',
    pleaseSelect: '请选择',
    lastWeek: '近一周',
    lastMonth: '近一个月',
    last3Month: '近三个月',
    clearFilter: '清空过滤条件',
    clearAll: '清空全部过滤条件',
    saveFilter: '保存',
    commitFilter: '提交',
    filterTitle: '筛选器',
  },
};
